<template>
  <h2 class="section__title section__title--error">{{ $t('main-page.rejected.back-to-pharmacy.default') }}</h2>
</template>

<script>
export default {
  name: 'default-text',
}
</script>
